import React from 'react'

import './BackButton.css'

const BackButton = () => {
  return (
    <a className='back-button' href='.'>Back</a>
  )
}

export default BackButton